import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/',
)({
  beforeLoad: () => {
    throw redirect({ to: '/devices/contract-and-cost/deal/contract' });
  },
});
